export default "__VITE_ASSET__CXf$hglL__"